module.exports = __webpack_public_path__ + "img/partner_01.a3f1bcc0.png";